export const AdminGroupID = "00000000-0000-8000-8000-000000000000";
export const ViewerGroupID = "00000000-0000-8000-8000-000000000001";
